import { Grid, Typography } from '@mui/material';
import { FilterList } from 'src/components/filterList/FilterList';
import { ILayout } from 'src/interfaces';
import { lang } from 'src/utils';

import { useAdditionalLocationGroup } from './AdditionalLocationGroup.hook';
import {
  ScheduleComponentLayoutWrapper,
  StepContentContainer,
  StepContentWrapper,
} from './AdditionalLocationGroups.styled';
import { AdditionalLocationGroupsTable } from './AdditionalLocationGroupsTable';

export const PAGINATION_HEIGHT = '65vh';

const AdditionalLocationGroups = (props: { layout: ILayout | undefined }) => {
  const {
    onChangeParams,
    onSortChangeHandle,
    selectedSortOption,
    locationGroups,
    locationGroupList,
    isLoadingLocationGroups,
    handlePageChange,
    currentPage,
    rowsPerPage,
    handleRowsPerPageChange,
    isAllSelected,
    handleSelectAll,
    handleClearSelection,
    selectedLocationGroups,
    handleSelectLocationGroup,
    isFuzzySearch,
    onSearchTypeChange,
    onChangeKeyword,
    onRemoveKeyword,
    onReset,
    matchedNames,
    isMatchLoading,
    isFetching,
  } = useAdditionalLocationGroup(props.layout);

  return (
    <StepContentWrapper>
      <StepContentContainer container spacing={2}>
        <Grid item>
          <Typography variant="h5" fontWeight={500}>
            {lang.scheduleComponent.additionalLocationGroups}
          </Typography>
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={12} md={3}>
            <FilterList
              onChangeFilter={onChangeParams}
              onRemoveKeyword={onRemoveKeyword}
              onChangeKeyword={onChangeKeyword}
              onReset={onReset}
              showReset
              hasExactSearch
              onSearchTypeChange={onSearchTypeChange}
              isFuzzySearch={isFuzzySearch}
              matchedNames={matchedNames ?? []}
              isMatchStatusLoading={isMatchLoading || isFetching}
            />
          </Grid>
          <ScheduleComponentLayoutWrapper item xs={12} md={9}>
            <AdditionalLocationGroupsTable
              rows={locationGroups}
              loading={isLoadingLocationGroups}
              page={currentPage}
              rowsPerPage={rowsPerPage}
              totalCount={locationGroupList?.totalCount || 0}
              totalPages={Math.ceil(
                (locationGroupList?.totalCount || 0) / rowsPerPage,
              )}
              selectedSortOption={selectedSortOption}
              selectedLocationGroups={selectedLocationGroups}
              isAllSelected={isAllSelected}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              onSortChange={onSortChangeHandle as any}
              onClearSelection={handleClearSelection}
              onSelectAll={handleSelectAll}
              onSelectLocationGroup={handleSelectLocationGroup}
              tableContainerHeight={PAGINATION_HEIGHT}
            />
          </ScheduleComponentLayoutWrapper>
        </Grid>
      </StepContentContainer>
    </StepContentWrapper>
  );
};

export default AdditionalLocationGroups;
